import { Vector3 } from 'three';
import { IModel2D } from '../models/standard/Model2DModel';
import { IProduct } from '../models/standard/ProductModel';
import { EElementType } from './Enums';

export enum EPendingType {
  ELEMENT = 'ELEMENT',
  PRODUCT = 'PRODUCT',
  MODEL_2D = 'MODEL_2D',
}

export interface IPendingElementData {
  type: EElementType;
  width: number;
  length: number;
  rotation: number;
  sideC?: number;
}

// NEW: Wrapper for Product Data
export interface IPendingProductData {
  productModel: IProduct;
  // Add any specific texture info here if needed for the ghost
}

// NEW: Wrapper for Model2D Data
export interface IPendingModel2DData {
  model2D: IModel2D;
}

export interface IPendingItem {
  type: EPendingType;
  // It can now be one of these three
  data: IPendingElementData | IPendingProductData | IPendingModel2DData; 
  
  // The callback triggers the ACTUAL add logic
  onConfirm: (position: Vector3, spaceUuid?: string) => void;
}